module.exports = __webpack_public_path__ + "static/media/channel_cat.bdca6c4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channel_cat.png
// module id = 857
// module chunks = 0